/**
 * @file: MilestoneWidget.tsx
 *
 * Renders a chat-bot workflow-summary header via a ` ```milestone ` fence: an
 * accent icon + a bold title, so a milestone can carry its own icon/color
 * (e.g. a green ✅ for a passed delivery check) instead of a plain markdown
 * heading.
 *
 * Fence payload: `{ title, icon?, color? }` — `icon` is an emoji, `color`
 * tints the title (defaults to slate).
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo } from 'react';
import { Text, View } from 'react-native';
import { MilestonePayload } from './payloads';

export const MilestoneWidget = memo(({ data }: { data: MilestonePayload }) => {
  const { rpx } = useResponsiveContext();
  const title = data?.title || '';
  const icon = data?.icon || undefined;
  const color = data?.color || '#1E293B';
  if (!title) return null;

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: rpx(10),
        marginBottom: rpx(1),
      }}
    >
      {icon ? (
        <Text style={{ fontSize: rpx(18), marginRight: rpx(6) }}>{icon}</Text>
      ) : null}
      <Text
        style={{
          flexShrink: 1,
          fontSize: rpx(17),
          fontWeight: '700',
          color,
        }}
      >
        {title}
      </Text>
    </View>
  );
});
